import { Component, OnInit } from '@angular/core';
import { GlobalUtilsService } from '../global-utils.service';
import { ActiveBreakpoint } from '../variables';

@Component({
  selector: 'app-spotlight-section',
  templateUrl: './spotlight-section.component.html',
  styleUrls: ['./spotlight-section.component.scss']
})
export class SpotlightSectionComponent {

  ActiveBreakpoint = ActiveBreakpoint;

  constructor(public globalUtilsService: GlobalUtilsService) {}
}
